import { CheckOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const PackageDescription = ({
  packageType,
  firstDayDate,
  secondDayDate,
}: any) => {
  const [description, setDescription] = useState<any>(null);

  useEffect(() => {
    if (!packageType || !firstDayDate || !secondDayDate) return;

    switch (packageType) {
      case "A":
        return setDescription({
          conference: "Ulaznica za konferenciju za oba dana",
          lunch: "Ručak za oba dana",
          caffe: "Dvije caffe pauze",
          applicationAccess: "Pristup aplikaciji Cyber Edukacija",
          expoZoneAccess: "Pristup CyberSec Expo zoni",
        });
      case "B":
        return setDescription({
          conference: `Ulaznica za konferenciju za ${dayjs(firstDayDate).format(
            "DD.MM.YYYY."
          )}`,
          lunch: "Ručak",
          caffe: "Caffe pauza",
          applicationAccess: "Pristup aplikaciji Cyber Edukacija",
          expoZoneAccess: "Pristup CyberSec Expo zoni",
        });

      case "C":
        return setDescription({
          conference: `Ulaznica za konferenciju za ${dayjs(
            secondDayDate
          ).format("DD.MM.YYYY.")}`,
          lunch: "Ručak",
          caffe: "Caffe pauza",
          applicationAccess: "Pristup aplikaciji Cyber Edukacija",
          expoZoneAccess: "Pristup CyberSec Expo zoni",
        });
      case "D":
        return setDescription({
          conference: "Ulaznica za konferenciju za oba dana",
          lunch: "Ručak za oba dana",
          caffe: "Dvije caffe pauze",
          applicationAccess: "Pristup aplikaciji Cyber Edukacija",
          expoZoneAccess: "Pristup CyberSec Expo zoni",
        });
    }
  }, [packageType, firstDayDate, secondDayDate]);

  return (
    <div className="text-start flex flex-col gap-4 md:gap-1 lg:gap-3 text-white font-bold text-base md:text-[8px] md:leading-3 lg:text-xs  2xl:text-sm mb-14">
      {description?.conference && (
        <div className="flex gap-2 items-start">
          <CheckOutlined className="text-custom-pink-900 text-lg md:text-xs lg:text-sm xl:text-base 2xl:text-xl" />
          <div>{description?.conference}</div>
        </div>
      )}
      {description?.lunch && (
        <div className="flex gap-2 items-start">
          <CheckOutlined className="text-custom-pink-900 text-lg md:text-xs lg:text-sm xl:text-base 2xl:text-xl" />
          <div>{description?.lunch}</div>
        </div>
      )}
      {description?.caffe && (
        <div className="flex gap-2 items-start">
          <CheckOutlined className="text-custom-pink-900 text-lg md:text-xs lg:text-sm xl:text-base 2xl:text-xl" />
          <div>{description?.caffe}</div>
        </div>
      )}
      {description?.applicationAccess && (
        <div className="flex gap-2 items-start">
          <CheckOutlined className="text-custom-pink-900 text-lg md:text-xs lg:text-sm xl:text-base 2xl:text-xl" />
          <div>{description?.applicationAccess}</div>
        </div>
      )}

      {description?.expoZoneAccess && (
        <div className="flex gap-2 items-start">
          <CheckOutlined className="text-custom-pink-900 text-lg md:text-xs lg:text-sm xl:text-base 2xl:text-xl" />
          <div>{description?.expoZoneAccess}</div>
        </div>
      )}
    </div>
  );
};

export default PackageDescription;
